import type { ApiConfig } from '@api/types';
import { typedMethodPost } from '@api/utils';
import type { CheckTimeInfoRequestDto, CheckTimeInfoResponseDto } from '@api/generated/models';
import type { WorldTimeApiResponse as WorldTimeApiResponseLocal } from './types';

// Domain types
import type { CheckTimeInfoResponse, WorldTimeApiResponse } from '@api/domain/types';

// Mappers
import { toCheckTimeInfoResponse, toWorldTimeApiResponse } from '@api/domain/mappers';

export default ({ baseURL }: ApiConfig) => ({
  checkTimeInfo: typedMethodPost<CheckTimeInfoRequestDto, CheckTimeInfoResponseDto, CheckTimeInfoResponse>(
    (data) =>
      fetch(`${baseURL}/v1/membership/CheckTimeInfo`, {
        method: 'POST',
        ...data,
      }),
    toCheckTimeInfoResponse
  ),
  getPublicTime: typedMethodPost<void, WorldTimeApiResponseLocal, WorldTimeApiResponse>(
    () =>
      fetch('http://worldtimeapi.org/api/ip', {
        method: 'GET',
      }),
    toWorldTimeApiResponse
  ),
});

// Re-export domain types for consumers
export type { CheckTimeInfoResponse, WorldTimeApiResponse };
